// hasUnsavedChanges() serialises the whole collection, so it must not run per dispatch.
export interface UnsavedChangesTracker {
    schedule(): void;
    flush(): void;
    cancel(): void;
}

export function createUnsavedChangesTracker(
    check: () => boolean,
    onChange: (value: boolean) => void,
    delay = 500,
): UnsavedChangesTracker {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const cancel = (): void => {
        if (timer !== null) {
            clearTimeout(timer);
            timer = null;
        }
    };
    const flush = (): void => {
        cancel();
        onChange(check());
    };
    return {
        schedule: () => {
            cancel();
            timer = setTimeout(flush, delay);
        },
        flush,
        cancel,
    };
}
